import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ResponsiveMenuComponent } from "./responsive-menu.component";
import { TranslateModule } from "@ngx-translate/core";
import { MatIconModule } from '@angular/material/icon';
import { ValgDKSearchModule } from '../input/valgdk-search/valgdk-search.module';
import { SidenavigationModule } from '../sidenavigation/sidenavigation.module';
import { A11yModule } from '@angular/cdk/a11y';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
        MatIconModule,
        ValgDKSearchModule,
        SidenavigationModule,
        A11yModule
    ],
  declarations: [
    ResponsiveMenuComponent
  ],
  exports: [
    ResponsiveMenuComponent
  ]
})
export class ResponsiveMenuModule {}
